import {jsonArrayMember, jsonMember, jsonObject} from "typedjson";
import {PitActivityEntityLink} from "./pit-activity-entity-link";
import {PitActivityEntityInvertLink} from "./pit-activity-entity-invert-link";


/** Мероприятие */
@jsonObject
export class PitActivity {
  /** ID мероприятия **/
  @jsonMember({name: "id", constructor: Number, emitDefaultValue: false, isRequired: false })
  private _id: number;

  /** Код мероприятия. **/
  @jsonMember({name: "code", constructor: String, emitDefaultValue: false, isRequired: false })
  private _code: string;

  /** Название мероприятия. **/
  @jsonMember({name: "name", constructor: String, emitDefaultValue: false, isRequired: false })
  private _name: string;

  /** Сокращенное название мероприятия. **/
  @jsonMember({name: "shortName", constructor: String, emitDefaultValue: false, isRequired: false })
  private _shortName: string;

  /** Текстовое описание */
  @jsonMember({name: "description", constructor: String, emitDefaultValue: false, isRequired: false })
  private _description: string;

  /** Тип мероприятия **/
  @jsonMember({name: "typeId", constructor: Number, emitDefaultValue: false, isRequired: false })
  private _typeId: number;

  /** Куратор мероприятия */
  @jsonMember({name: "curatorId", constructor: Number, emitDefaultValue: false, isRequired: false })
  private _curatorId: number;

  /** Мероприятие завершено */
  @jsonMember({name: "isFinished", constructor: Boolean, emitDefaultValue: false, isRequired: false})
  private _isFinished: boolean;

  /** Дата окончания мероприятия */
  @jsonMember({name: "finishDate", constructor: Date, emitDefaultValue: false, isRequired: false})
  private _finishDate: Date;

  /** Мероприятие удалено */
  @jsonMember({name: "isDeleted", constructor: Boolean, emitDefaultValue: false, isRequired: false})
  private _isDeleted: boolean;

  /** План?? мероприятия */
  @jsonMember({name: "subjectAreaId", constructor: Number, emitDefaultValue: false, isRequired: false })
  private _subjectAreaId: number;

  /** Ссылки на связанные мероприятия */
  @jsonArrayMember(PitActivityEntityLink, {name: "entityLinks", emitDefaultValue: false, isRequired: false})
  private _entityLinks: PitActivityEntityLink[] = [];

  @jsonArrayMember(PitActivityEntityInvertLink, {name: "entityInvertLinks", emitDefaultValue: false, isRequired: false})
  private _entityInvertLinks: PitActivityEntityInvertLink[] = [];


  get id(): number {
    return this._id;
  }

  set id(value: number) {
    this._id = value;
  }

  get code(): string {
    return this._code;
  }

  set code(value: string) {
    this._code = value;
  }

  get name(): string {
    return this._name;
  }

  set name(value: string) {
    this._name = value;
  }

  get description(): string {
    return this._description;
  }

  set description(value: string) {
    this._description = value;
  }

  get typeId(): number {
    return this._typeId;
  }

  set typeId(value: number) {
    this._typeId = value;
  }

  get curatorId(): number {
    return this._curatorId;
  }

  set curatorId(value: number) {
    this._curatorId = value;
  }

  get isFinished(): boolean {
    return this._isFinished;
  }

  set isFinished(value: boolean) {
    this._isFinished = value;
  }

  get finishDate(): Date {
    return this._finishDate;
  }

  set finishDate(value: Date) {
    this._finishDate = value;
  }

  get isDeleted(): boolean {
    return this._isDeleted;
  }

  set isDeleted(value: boolean) {
    this._isDeleted = value;
  }

  get shortName(): string {
    return this._shortName;
  }

  set shortName(value: string) {
    this._shortName = value;
  }

  get subjectAreaId(): number {
    return this._subjectAreaId;
  }

  set subjectAreaId(value: number) {
    this._subjectAreaId = value;
  }

  get entityLinks(): PitActivityEntityLink[] {
    return this._entityLinks;
  }

  set entityLinks(value: PitActivityEntityLink[]) {
    this._entityLinks = value;
  }

  get entityInvertLinks(): PitActivityEntityInvertLink[] {
    return this._entityInvertLinks;
  }

  set entityInvertLinks(value: PitActivityEntityInvertLink[]) {
    this._entityInvertLinks = value;
  }
}

